// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__13my2","clinicsSelect":"TableHeading_clinicsSelect__clTuj"};